import React, { FC } from 'react';
import { PageHeader, UserStateComponent } from '../../../components';
import { useTranslation } from '../../../translations';
import { SurchargesList } from './surchargesList';

export const SurchargesContainer: FC = () => {
  const { ts } = useTranslation();
  return (
    <UserStateComponent>
      <PageHeader>{ts('common.surcharges')}</PageHeader>
      <SurchargesList />
    </UserStateComponent>
  );
};
